import React from 'react';
import PricingSection from '../components/PricingSection';

const Pricing: React.FC = () => {
  return (
    <div className="pricing-page">
      <PricingSection />
    </div>
  );
};

export default Pricing;
